<div class="content-wrapper table-full-bx">
	<div class="account-settings">
		<div class="row">
			<div class="col-lg-12">
				<div class="ibox ">
					<div class="ibox-body">
						<div class="iboxcontent">
							<h3>Account Settings</h3> </div>
						<!-- Account settings  -->
						<div class="row">
							<div class="col-md-12 col-lg-3 col-sm-12">
								<!-- Tabs nav -->
								<div class="nav  nav-pills nav-pills-custom nav-pills-custom pills-custom">
									<a class="nav-link mb-3 p-3 " href="javascript:void(0);" routerLink="/account-settings/change-password"> <span class=" ">Change password</span> </a>
									<a class="nav-link mb-3 p-3  " href="javascript:void(0);" routerLink="/account-settings/notification"> <span class=" ">Notifications</span> </a>
									<a class="nav-link mb-3 p-3 " href="javascript:void(0);" routerLink="/account-settings/save-card" *ngIf="userDatas?.Recruiter?.userType != 'SUB_RECRUITER'" hidden> <span class=" ">Saved cards</span> </a>
									<a class="nav-link mb-3 p-3  active" href="javascript:void(0);" routerLink="/account-settings/inventory-history"  *ngIf="userDatas?.Recruiter?.userType == 'SUPER_RECRUITER' || (userDatas?.Recruiter?.userType == 'SUB_RECRUITER' && userPermissionData?.viewActivePlans == 1)" > <span class="">Subscriptions</span> </a>
									<a class="nav-link mb-3 p-3 " href="javascript:void(0);" routerLink="/account-settings/billing-address" *ngIf="userDatas?.Recruiter?.userType != 'SUB_RECRUITER'" > <span class=" ">Billing address</span> </a>
									<a class="nav-link mb-3 p-3  " href="javascript:void(0);" routerLink="/account-settings/my-templates" *ngIf="userDatas?.Recruiter?.userType != 'SUB_RECRUITER'" > <span class=" ">My templates</span> </a>
								</div>
							</div>
							<div class="col-lg-9 col-sm-12 ">
								<!-- Tabs content -->
								<div class="tab-content" id="v-pills-tabContent">
									<div class="tab-pane fade  bg-box show active ">
										<div class="flexbox">
											<div class="iboxcontent">
												<h2 class="mainTitle">My Subscriptions</h2> </div>
											<div class="input-group-icon input-group-icon-left" *ngIf="userDatas?.Recruiter?.userType != 'SUB_RECRUITER'">
												<div class="col-list-right"> <a href="javascript:void(0)" routerLink="/account-settings/subscription/subscription-plan" class="commonBtn2 buy-more">Buy More</a> </div>
											</div>
										</div>
										<ul class="nav nav-pills job-list mt-0">
											<li> <a routerLink="/account-settings/inventory-history">Active Plan</a> </li>
											<li class="active"> <a href="javascript:void(0)" routerLink="/account-settings/subscription">Plan History</a> </li>
										</ul>
										<div class="table-scroll table-wrapper table-responsive mt-5">
											<table id="example" class="table  table-bordered m-0  table-hover" style="width:100%">
												<thead>
													<tr>
														<th class="sorting_asc">Subscriptions</th>
														<th class="sorting_asc">Plan Type</th>
														<th class="sorting_asc">Start Date </th>
														<th class="sorting_asc"> End Date</th>
														<th class="sorting_asc">Status</th>
														<th class="sorting_asc">Amount</th>
														<th class="sorting_disabled" data-orderable="false"> Action</th>
													</tr>
												</thead>
												<tbody>
													<tr *ngFor="let data of subscriptionsData | paginate: { id:'pagination', itemsPerPage: pagination.limit, currentPage: currentPage ,totalItems: pagination.totalItems};let i=index">
														<td><a class="noHand">{{data?.planName}} / {{data?.validityType == 'month' ? "Monthly" : "Yearly"}} </a></td>
														<td><a class="noHand">
															<span *ngIf="data?.planType == 0">Subscriptions Plan</span>
															<span *ngIf="data?.planType == 1">Inventory Plan</span>
															 </a></td>
                                                        <td><a class="noHand">{{data?.createdAt | date: "d/M/YYYY"}} </a></td>
                                                        <td><a class="noHand">{{data?.isFreePlan!=1?(data?.endDate | date: "d/M/YYYY"):'-'}} </a></td>
                                                        <td>
                                                            <a class="noHand">
                                                                <span class="red" *ngIf="data?.status == 0">Pending</span>
                                                                <span class="green" *ngIf="data?.status == 1">Success</span> 
                                                                <span class="red" *ngIf="data?.status == 2">Failed</span>
                                                            </a>
                                                        </td>
                                                        <td><a class="noHand">$ {{(data?.planAmount)?(data?.planAmount | number : '1.2-2'):0}} </a></td>
                                                        <td>
                                                            <div class="action-wrap table-action" *ngIf="data?.status == 1">
                                                                <a href="javascript:void(0)" (click)="downloadInvoice(data.id)"><span><input type="radio" id="featured-2" name="featured">Download Invoice</span></a>
                                                            </div>
                                                        </td>
													</tr>
												</tbody>
											</table>
                                            <div class="noDataFound" *ngIf="subscriptionsData.length == 0">
                                                <h2>No Records found</h2>
                                            </div>
										</div>
                                        <div class="col-sm-12 p-0" *ngIf="subscriptionsData.length > 9">
                                            <ul class="pagination ">
                                                <pagination-controls id="pagination" (pageChange)="pageChanged($event)" previousText="&#60;" nextText="Next" firstText="&#62;" lastText="Last"></pagination-controls> 
                                            </ul>
                                        </div>
									</div>
								</div>
							</div>
						</div>
						<!-- End -->
					</div>
				</div>
			</div>
		</div>
	</div>
</div>